import { createAction } from "@reduxjs/toolkit";
import axios from 'apis';
import _omit from 'lodash/omit';
import { asyncThunkWrapper } from "helpers/asyncThunkWrapper";

export const getSuperbillGoals = asyncThunkWrapper({ 
  model: 'superbillGoals', 
  action: 'getSuperbillGoals', 
  func: async ({ offset = 0 }) => {
    const attributes = ['id', { clinician: ['id', 'first_name', 'last_name'] }, 'emails', 'updated_at']
    const params = { limit: 25, offset, orders: { updated_at: 'desc' }, attributes };
    const response = await axios.get('/superbill_flow/superbill_goals', { params });

    return response.data;
  } 
});
export const getSuperbillGoal = asyncThunkWrapper({ 
  model: 'superbillGoals', 
  action: 'getSuperbillGoal', 
  func: async (id) => {
    const params = { attributes: ['id', { clinician: ['id', 'first_name', 'last_name'] }, 'emails', 'updated_at'] };
    const response = await axios.get(`/superbill_goals/${id}`, { params });

    return response.data;
  } 
});
export const createSuperbillGoal = asyncThunkWrapper({ 
  model: 'superbillGoals', 
  action: 'createSuperbillGoal', 
  func: async (superbill_goal) => {
    const attributes = ['id', { clinician: ['id', 'first_name', 'last_name'] }, 'emails', 'updated_at'];
    const response = await axios.post(`/superbill_flow/superbill_goals`, { superbill_goal: _omit(superbill_goal, ['localClinician']), attributes });

    return response.data;
  } 
});
export const updateSuperbillGoal = asyncThunkWrapper({ 
  model: 'superbillGoals', 
  action: 'updateSuperbillGoal', 
  func: async ({ id, ...fields }) => {
    const response = await axios.patch(`/superbill_goals/${id}`, { superbill_goal: _omit(fields, ['localClinician']) });

    return { status: response.status, superbill_goal: { id, ...fields } };
  } 
});
export const deleteSuperbillGoal = asyncThunkWrapper({ 
  model: 'superbillGoals', 
  action: 'deleteSuperbillGoal', 
  func: async (id) => {
    const response = await axios.delete(`/superbill_goals/${id}`);

    return { status: response.status, id };
  } 
});
export const clearLocalSuperbillGoals = createAction('superbillGoals/clearLocalSuperbillGoals');
export const clearLocalActiveSuperbillGoal = createAction('superbillGoals/clearLocalActiveSuperbillGoal');